module.exports = __webpack_public_path__ + "static/media/Seamind.afef5c9f.mp4";